
/* eslint-disable */
import { defineComponent } from 'vue'
import recherchevehicule from "@/services/recherche_page.services";

export default defineComponent({
  name: 'rangeInput',
  props: {
    format: Boolean,
    locale: String,
    group: String,
    min: Number,
    max: Number,
    minInput: Number,
    maxInput: Number,
    startLayout: Number,
    widthLayout: Number,
    step: Number
  },
  setup: () => {
    const {
      state,
      refreshFilter
    } = recherchevehicule;
    return {
      state,
      refreshFilter
    }
  },
  data () {
    return {
      minValue: Number(this.minInput || this.min),
      maxValue: Number(this.maxInput || this.max),
      startLayout: 0,
      widthLayout: 100
    }
  },
  methods: {
    resetSlider: function(reset = false) {
      this.minValue = Number(reset ? this.min : this.minInput);
      this.maxValue = Number(reset ? this.max : this.maxInput);

      // Fonctionnalité réalisée si les valeurs Min/Max sont atteintes
      if (this.minValue == this.min && this.maxValue == this.max) {
        // Suppression du filtre actif
        const index = this.state.activeFilters.indexOf(this.group + 'ButtonReset');
        if (index >= 0) {
          this.state.activeFilters.slice(index, 1);
        }
        // Masquage du bouton de réinitialisation
        document.getElementById(this.group + 'ButtonReset')?.setAttribute('style', "display: none;");
      } else {
        // Affichage du bouton de réinitialisation
        document.getElementById(this.group + 'ButtonReset')?.setAttribute('style', "display: block;");
      }

      // Initialisation du slider
      this.updateSlider();
      this.refreshFilter();
    },
    updateSlider: function() {
      // Seules les années peuvent se chevaucher
      let stepRef = this.group != 'year' ? Number(this.step || 1) : 0;

      // Ajustement du step sur les grands écarts de valeurs
      const diff = Number(this.max) - Number(this.min);
      if (diff >= 100000000) {
        stepRef = 100000;
      } else if (diff >= 10000000) {
        stepRef = 10000;
      } else if (diff >= 1000000) {
        stepRef = 1000;
      }

      const minRef = stepRef + Number(this.min);
      const maxRef = Number(this.max) - stepRef;
      // Fonctionnalité réalisée uniquement si les champs Min/Max sont différents
      if (minRef != maxRef) {
        // Protection contre les collisions
        if (Number(this.minValue) > (maxRef - stepRef)) {
          // Limite Max
          this.minValue = maxRef - stepRef;
          this.maxValue = Number(this.max);
        } else if (Number(this.maxValue) < (minRef + stepRef)) {
          // Limite Min
          this.minValue = Number(this.min);
          this.maxValue = minRef + stepRef;
        } else if (Number(this.minValue) > Number(this.maxValue)) {
          // Déplacement du curseur Min
          this.maxValue = Number(this.minValue) + stepRef;
        } else if (Number(this.maxValue) < Number(this.minValue)) {
          // Déplacement du curseur Max
          this.minValue = Number(this.maxValue) - stepRef;
        }

        // Détermine le background
        let leftPosition = (Number(this.minValue) - minRef) * 100 / (maxRef - minRef);
        let rightPosition = (maxRef - Number(this.maxValue)) * 100 / (minRef - maxRef);
        this.startLayout = leftPosition;
        this.widthLayout = 100 - leftPosition + rightPosition;

        // Mise à jour des valeurs du filtre
        this.state.group = String(this.group);
        switch (this.state.group) {
          case "year":
            this.state.filter.maxYear = Number(this.maxValue);
            this.state.filter.minYear = Number(this.minValue);
            break
          case "price":
            this.state.filter.maxPrice = Number(this.maxValue);
            this.state.filter.minPrice = Number(this.minValue);
            break
          case "odometer":
            this.state.filter.maxOdometer = Number(this.maxValue);
            this.state.filter.minOdometer = Number(this.minValue);
            break
        }

        // Suppression du bouton de réinitialisation si les valeurs Min/Max sont atteintes
        if (Number(this.minValue) <= minRef && Number(this.maxValue) >= maxRef) {
          document.getElementById(this.group+'ButtonReset')?.setAttribute('style', "display: none;");
        }
      }
    }
  },
  mounted() {
    // Exploitation des valeurs Input au chargement
    this.resetSlider(false);
  }
})
